import { generateClient, GraphQLResult } from "aws-amplify/api";
import { Role } from "db/definitions";
// @ts-ignore
import { listRoles } from "graphql/queries";

export async function getRoles(): Promise<Role[]> {
	const roles: Role[] = [];
	let nextToken;
	while (nextToken !== null) {
		interface QueryResponse {
			listRoles: {
				items: Role[];
				nextToken: string | null;
			};
		}
		const client = generateClient({ authMode: "userPool" });
		const response = (await client.graphql({
			query: listRoles,
			authMode: "userPool",
		})) as unknown as GraphQLResult<QueryResponse>;
		nextToken = response.data.listRoles.nextToken;
		for (const role of response.data.listRoles.items) {
			roles.push(role);
		}
	}
	return roles;
}
